
import mainShared     from '_core/main-shared';
// import navbar         from '../public-pages/shared/navbar';
import navbar         from '../new-public-pages/shared/Navbar';
import UiHelper       from '_utils/UiHelper';

const mainPublic = {

  init: function() {
    mainShared.init();
    navbar.init();

    const cmsRegistrationButtons = document.querySelectorAll('.cms-registration-button');

    if (cmsRegistrationButtons) {
      cmsRegistrationButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          const source = e.target.getAttribute('data-source') || null;
          this.handleCmsRegistrationButtonClick(e, source);
        });
      });
    }
  },

  handleCmsRegistrationButtonClick(e, source=null) {
    e.stopPropagation();

    const signUpUrl = source ? `/sign-up?source=${source}` : '/sign-up';
    UiHelper.navigate(signUpUrl);
  }
};

export default mainPublic;
